// extracted by mini-css-extract-plugin
module.exports = {"PaidModal":"paid_PaidModal__a_eKX","btn":"paid_btn__lF1WT"};